import { LoginUser } from "../types/authentication";
import initialState from "../store/initialState";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";

export interface AuthenticationState {
  isAuthenticated: boolean;
  loginUser: LoginUser;
  errors?: string[];
}

export default function authReducer(
  state: AuthenticationState = initialState.authentication,
  action: AnyAction
): AuthenticationState {
  switch (action.type) {
    case internalActionKeys.AUTHENTICATE_SUCCESS:
      return {
        isAuthenticated: true,
        loginUser: { ...action.user },
        errors: []
      };
    case internalActionKeys.LOGOUT:
      return { ...initialState.authentication };
    default:
      return state;
  }
}
